import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { groupBy } from 'lodash'

import { landAxios } from '@Root/utils/landAxios'
import MyHouseAuth from '@Types/entities/MyHouseAuth'
import { FETCH_STATUS } from '@Root/contants'
import MyHouseAuthResponse from '@Types/entities/MyHouseAuthResponse'

export const fetchMyHouseAuth = createAsyncThunk('myhouse/auth', async () => await (await landAxios.get('/myhouse/auth')).data)

export type MyHouseState = {
  complexNo: number
  authComplexNoMap: {
    [key: string]: MyHouseAuth[]
  }
  authHouseNoMap: {
    [key: string]: MyHouseAuth
  }
  fetchStatus: FETCH_STATUS
}

const initialState: MyHouseState = {
  authComplexNoMap: {},
  authHouseNoMap: {},
  fetchStatus: FETCH_STATUS.INITIAL,
} as MyHouseState

const myHouseSlice = createSlice({
  name: 'myhouse',
  initialState,
  reducers: {
    updateComplexNo: (state: MyHouseState, action: PayloadAction<number>) => {
      state.complexNo = action.payload
    },
  },
  extraReducers: {
    [fetchMyHouseAuth.fulfilled.type]: (state: MyHouseState, action: PayloadAction<MyHouseAuthResponse>) => {
      state.fetchStatus = FETCH_STATUS.SUCCESS
      state.authHouseNoMap = action.payload.houseNoMap as { [key: string]: MyHouseAuth }
      state.authComplexNoMap = groupBy(action.payload.houseNoMap, (myhouseAuth: MyHouseAuth) => myhouseAuth.complexNo)
    },
    [fetchMyHouseAuth.pending.type]: (state: MyHouseState) => {
      state.fetchStatus = FETCH_STATUS.PENDING
    },
    [fetchMyHouseAuth.rejected.type]: (state: MyHouseState) => {
      state.fetchStatus = FETCH_STATUS.FAILURE
    },
  },
})

export const { updateComplexNo } = myHouseSlice.actions
export default myHouseSlice.reducer
